// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vatavqkrxrdjnfxmnrmi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZhdGF2cWtyeHJkam5meG1ucm1pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY5NzE1OTQsImV4cCI6MjA1MjU0NzU5NH0.uSti9tkSwj_2dmsbK_4tG6EOHkD1f7memtYW1zZHfeE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);